import { Flag, PaperPlaneTilt as Send } from '@phosphor-icons/react';
import { Helmet } from 'react-helmet-async';
import { Breadcrumbs } from '@/components/seo/Breadcrumbs';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

import { useState } from 'react';
import { toast } from 'sonner';

export default function RaporteazaListare() {
  const canonicalUrl = 'https://roautomarket.ro/incredere/raporteaza-listare';
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    // In production this would submit to an edge function
    await new Promise(r => setTimeout(r, 1000));
    toast.success('Raportul a fost trimis. Echipa noastră va investiga în 24 de ore.');
    (e.target as HTMLFormElement).reset();
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Raportează o Listare | Trust Center – RO Auto Market</title>
        <meta name="description" content="Raportează un anunț suspect pe RO Auto Market. Echipa noastră investighează fiecare raport în 24 de ore." />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content="Raportează o Listare – RO Auto Market" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
      </Helmet>

      <section className="surface-dark pt-4 pb-6 md:py-10 px-4">
        <div className="container mx-auto max-w-3xl">
          <Breadcrumbs items={[
            { label: 'Trust Center', href: '/incredere' },
            { label: 'Raportează o Listare', href: '#' }
          ]} className="mb-6" />
          <div className="flex items-center gap-3 mb-4">
            <Flag className="w-8 h-8 text-primary" />
            <h1 className="text-3xl md:text-4xl font-bold text-foreground">Raportează o Listare</h1>
          </div>
          <p className="text-lg text-muted-foreground">Ai văzut ceva suspect? Raportează și echipa noastră va investiga în 24 de ore.</p>
        </div>
      </section>

      <section className="py-12 px-4">
        <div className="container mx-auto max-w-3xl">
          <Card>
            <CardHeader>
              <CardTitle>Formular de Raportare</CardTitle>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <Label htmlFor="reason">Motiv raportare</Label>
                  <Select required name="reason">
                    <SelectTrigger>
                      <SelectValue placeholder="Selectează motivul" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="fraud">Suspiciune de fraudă</SelectItem>
                      <SelectItem value="fake-photos">Fotografii false / de pe internet</SelectItem>
                      <SelectItem value="wrong-price">Preț incorect / înșelător</SelectItem>
                      <SelectItem value="wrong-km">Kilometraj fals</SelectItem>
                      <SelectItem value="duplicate">Anunț duplicat</SelectItem>
                      <SelectItem value="stolen">Vehicul furat</SelectItem>
                      <SelectItem value="other">Altul</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label htmlFor="url">URL-ul listării</Label>
                  <Input id="url" name="url" type="url" placeholder="https://roautomarket.ro/listing/..." required />
                </div>
                <div>
                  <Label htmlFor="email">Email-ul tău</Label>
                  <Input id="email" name="email" type="email" placeholder="exemplu@email.com" required />
                </div>
                <div>
                  <Label htmlFor="details">Detalii suplimentare</Label>
                  <Textarea id="details" name="details" placeholder="Descrie ce ai observat suspect..." rows={4} />
                </div>
                <Button type="submit" disabled={loading} size="lg" className="w-full">
                  <Send className="w-5 h-5 mr-2" />
                  {loading ? 'Se trimite...' : 'Trimite raportul'}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
}
